import React from 'react';
import { Modal, Box, Typography, Button, Stack ,IconButton} from '@mui/material';
import { minWidth } from '@mui/system';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
// import CloseIcon from '@mui/icons-material/Close';
// import StarIcon from '@mui/icons-material/DoneAll';
// import PlusIcon from '@mui/icons-material/Add';
import ArrowIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import StarRateIcon from "@mui/icons-material/StarRate";

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  color: 'white',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  width: 600,
  textAlign: 'center',
};

const planTextStyle = {
  borderRadius: 2,
  width: 140,
  minWidth: 140,
  fontWeight: 'bold',
  color: 'white',
  textTransform: 'none',
  px: 2,
  py: 2,
  fontSize: '18px',
  textAlign: 'center',
};

// const HtmlTooltip = styled(({ className, ...props }) => (
//     <Tooltip  {...props} classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: '#f5f5f9',
//       color: 'rgba(0, 0, 0, 0.87)',
//       maxWidth: 500,
//       fontSize: theme.typography.pxToRem(12),
//       border: '1px solid #dadde9',
//     },
//   }));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 600,
    maxHeight: 500, 
    overflowY: 'auto', 
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: theme.spacing(1.5),
  },
}));

// const HtmlTooltip = styled(({ className, ...props }) => (
//   <Tooltip
//     {...props}
//     arrow
//     placement="left"
//     PopperProps={{
//       modifiers: [
//         {
//           name: 'offset',
//           options: {
//             offset: [0, -20], // You can tweak this to [0, -10] or [0, 10] if needed
//           },
//         },
//       ],
//     }}
//     classes={{ popper: className }}
//   />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: '#f5f5f9',
//     color: 'rgba(0, 0, 0, 0.87)',
//     maxWidth: 500,
//     maxHeight: 600,
//     overflowY: 'auto',
//     fontSize: theme.typography.pxToRem(12),
//     border: '1px solid #dadde9',
//     padding: theme.spacing(1.5),
//   },
// }));

const UpgradePopup = ({ open, handleClose, handleOpenSubscription }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
      <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: -16,
            right: -12,
            color: '#C0C4D6',
          }}
        >
          <CancelOutlinedIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Compare Subscription Plans
        </Typography>

        {/* <Typography variant="h5" sx={{mb:6,mt:4,ml:2,textAlign:'center',fontWeight:600,color:'#ffffff'}}>SPECIAL Limited Time Offer!<br/>Use Coupon code <u style={{color:"#fa75e5"}}>MAY1</u> on the Purchase Details popup and Save 15%, 20% and 25% on Quarterly, Half-yearly and Annual plans respectively.
          <br/><br/>Offer valid only till 2nd May. HURRY!</Typography>
        <br/> */}

        <Stack direction="row" justifyContent="center" spacing={2} mb={3}>
        <HtmlTooltip
            title={
                <React.Fragment>
                <Typography color="inherit" sx={{fontSize:"16px",fontWeight:800}}>Free Plan:</Typography>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>15 Mins delayed data across all charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Limited Index Instruments with only few active strikes for options data</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Market Profile charts with restricted features and limited historical data access</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Options Table with delayed data and limited features</Typography>
                </Box>
                <Box display='flex' sx={{mt:1,mb:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Greeks Table and Index Table pages</Typography>
                </Box>
                <Box display='flex' sx={{mt:1,mb:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Multiple options strategies Payoff charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1,mb:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Strike wise Open Interest, IV and Volumes visualization Charts</Typography>
                </Box>
                </React.Fragment>
                }
                 >
                <Typography sx={{ ...planTextStyle, bgcolor: '#20294A',cursor:"pointer" }}>Free</Typography>
        </HtmlTooltip>
        <HtmlTooltip
            title={
                <React.Fragment>
                <Typography color="inherit" sx={{fontSize:"16px",fontWeight:800}}>Professional Plan:</Typography>
                {/* ============================================================
                    OLD - Premium Plan features (DEPRECATED - before Expert merge)
                    Replaced by: Updated Premium with merged Expert features below
                    See: DASHBOARD_MENU_MIGRATION_SUMMARY.md
                    ============================================================ */}
                {/* <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>Faster data:</b> 2 Mins delayed data across all charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Limited Index Instruments with only few active strikes for Index options data</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Only Stock Futures data access with Stocks plan</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Market Profile charts with historical data and special tooltips for useful data points</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Only Custom KRLs and a few Auto-Gen KRLs Supported</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Unique short timeframe Candlestick and Line charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Advanced IV Curve and Open Interest Visualization Charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Options Table with advanced data points</Typography>
                </Box>
                <Box display='flex' sx={{mt:1,mb:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Greeks Table and Index Table pages</Typography>
                </Box> */}
                
                {/* NEW - Updated Premium Plan with merged Expert features (3-tier system) */}
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0,fontWeight:600}}>Real time precision feed off NSE servers across all charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Index FnO Instruments</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Stocks FnO data access with Stocks plan</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success' ></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Multi-window chart view</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success' ></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>All Free tier charts - with Live data from NSE</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Market Profile charts with historical data and special tooltips for useful data points</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Custom and Anchored KRLs across all instruments and a few Index specific Auto-Gen KRLs Supported</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Proprietary Spectrum, NTM VolX<sup>™</sup> and NTM OI charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Compare and analyse data changes between recent time instances in Options Table, OI, Gamma and Inventory Visualization charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Options Table with advanced data points</Typography>
                </Box>
                </React.Fragment>
                }
                 >
                <Typography sx={{ ...planTextStyle, bgcolor: '#23B1BA',cursor:"pointer" }}>Professional</Typography>
        </HtmlTooltip>
        {/* ============================================================
            OLD - Expert tier (DEPRECATED)
            Removed: Expert tier merged into Premium in new 3-tier system
            See: DASHBOARD_MENU_MIGRATION_SUMMARY.md
            ============================================================ */}
        {/* <HtmlTooltip
            title={
                <React.Fragment>
                <Typography color="inherit" sx={{fontSize:"16px",fontWeight:800}}>Expert Plan:</Typography>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>Fast data:</b> 2 Mins delayed data across all charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Index FnO Instruments</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Stocks FnO data access with Stocks plan</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success' ></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Multi-window chart view</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Market Profile charts with historical data and special tooltips for useful data points</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Custom and Anchored KRLs across all instruments and a few Index specific Auto-Gen KRLs Supported</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Unique short timeframe Candlestick and Line charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0,fontWeight:500}}>Proprietary Spectrum, NTM Volx and NTM OI charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Advanced IV Curve and Open Interest Visualization Charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0,fontWeight:500}}>Advanced Gamma, Gamma Exposure and Market Visualization Charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Compare and analyse data changes between recent time instances in Options Table, OI, Gamma and Inventory Visualization charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Options Table with advanced data points</Typography>
                </Box>
                <Box display='flex' sx={{mt:1,mb:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Greeks Table and Index Table pages</Typography>
                </Box>
                </React.Fragment>
                }
                 >
                <Typography sx={{ ...planTextStyle, bgcolor: '#E7B401',cursor:"pointer" }}>Expert</Typography>
        </HtmlTooltip> */}
        <HtmlTooltip
            title={
                <React.Fragment>
                <Typography color="inherit" sx={{fontSize:"16px",fontWeight:800}}>Elite Plan:</Typography>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0,fontWeight:600}}>Real time precision feed off NSE servers across all charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Index FnO Instruments</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success'></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}><b>All</b> liquid Stocks FnO data access with Stocks plan</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success' ></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Multi-window chart view</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <ArrowIcon color ='success' ></ArrowIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>All Free and Professional tier charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Orderflow Charts with proprietary IB/IS, LLT signals and real-time COT reading</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Unique Replay feature in Orderflow charts for an advanced post market analysis.</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success'></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Smart Candlestick<sup>™</sup> charts with Micro Balance<sup>™</sup> (MB) boxes and Real-time Orderflow signals</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>MFlow<sup>™</sup> Indicator on Smart Candlestick<sup>™</sup> charts - proprietary momentum flow analysis</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Proprietary Gamma Density and Exposure Charts</Typography>
                </Box>
                <Box display='flex' sx={{mt:1}} >
                  <CheckIcon color ='success' ></CheckIcon>
                  <Typography sx={{fontSize:"14px",ml:1,mt:0,mb:0}}>Global Bookmarks for saving multi-window views with customizable settings and drawings</Typography>
                </Box>
                </React.Fragment>
                }
                 >
                   <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#EC6C10',
        borderRadius: 2,
        cursor: 'pointer',
        overflow: 'hidden',
        
      }}
    >

      <Box
        sx={{
          width: 24,
          height: '100%',
          background:
                    "linear-gradient(218.09deg, #C7E7F9 6.56%, #3DBEE7 48.46%, #3DBEE7 90.36%)",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: "rotate(45deg)",
          ml:1,
          mt:-3.5
          
        }}
      >
        <StarRateIcon sx={{ color: 'white', fontSize: 16 }} />
      </Box>

      <Typography sx={{ ...planTextStyle, bgcolor: '#EC6C10',cursor:"pointer",ml:-2 }}>Elite</Typography>
    </Box>
                
        </HtmlTooltip>

          {/* <Typography sx={{ ...planTextStyle, bgcolor: '#20294A' }}>Free</Typography> */}
          {/* <Typography sx={{ ...planTextStyle, bgcolor: '#23B1BA' }}>Premium</Typography> */}
          {/* <Typography sx={{ ...planTextStyle, bgcolor: '#E7B401' }}>Expert</Typography> */}
          {/* <Typography sx={{ ...planTextStyle, bgcolor: '#EC6C10' }}>Elite</Typography> */}
        </Stack>

        <Typography variant="body2" color="#C0C4D6" mb={3} sx={{fontSize:"16px"}}>
          Upgrade now for advanced chart options and analysis tools based on your trading needs.
        </Typography>

        <Button
          variant="contained"
          sx={{
            bgcolor: '#3F53F1',
            color: 'white',
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: 20,
            height: 42,
            py:1,
            px: 4,
            '&:hover': {
              bgcolor: '#3342C9',
            },
          }}
          onClick={handleOpenSubscription}
        >
          Compare and Purchase
        </Button>
      </Box>
    </Modal>
  );
};

export default UpgradePopup;
